import React, { useState, useEffect } from "react";
import { instance } from "../../axios";
import "bootstrap/dist/css/bootstrap.css";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { BgLoader, UiButton, UiInput, PageError } from "../../ui";
import { LoginUser, setStorage } from "../../helper";
import { useStore } from "../../state.js";
import { useNavigate, Link, useParams, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";

import { PaymentForm } from '../../pay_form'

const QuickPay = ({ ...props }) => {
  const { auth, setAuth } = useStore((state) => state);
  let navigat = useNavigate();
  let { id } = useParams();
  const [loader, showLoader] = useState(false);
  const [defaultAmount, setdefaultAmount] = useState(null);
  const [searchParams] = useSearchParams();

  //const [pstate, setTitle] = useOutletContext(); // <-- access context value

  const [state, setState] = useState({});



  const fetchData = () => {
    instance
      .get("/quick_pay?id=" + id)
      .then(function (response) {
        setState({ ...state, ...response.data })
      })
      .catch(function (error) { })
      .then(function () { });
  }



  useEffect(() => {
    fetchData()
    var amount = searchParams.get("amount");
    if(amount > 0){
      setdefaultAmount(amount)
    }
  }, []);






  if (state.status == 'error') {
    return (
      <PageError msg={state.msg} />
    )
  }
  //if (pstate.company.online_pay == 0) {
    //return (
      //<PageError msg='Access denied!' />
    //)
  //}



  return (
    <div className="container">
      <Helmet>
        <title>Online Payment</title>
        {state.company && state.company.logo && <link rel="icon" type="image/x-icon" href={state.company.logo}></link>}
      </Helmet>
      {loader && (
        <div className="overlay">
          <div className="overlay__inner">
            <div className="overlay__content"><span className="spinner"></span></div>
          </div>
        </div>
      )}
      <>
        {state.company ?
          <>
            <header className="navbar navbar-light sticky-top bg-white align-items-center d-flex shadow-sm py-2 px-3 mb-3">

              <a className="navbar-brand me-0" href="#">
                {state.company.logo ?
                  <img className="logo" src={state.company.logo} />
                  : <div></div>}

              </a>

              <div className="flex-grow-1 col-9 ps-3">

                <h1 className="mb-0 fs-3">{state.company.company}</h1>

              </div>
            </header>


            <div className="container-fluid">
              <div className="row">


                <main className="p-2">
                  <section className="content d-inline-block w-100">
                    <div className="container-fluid">
                      <div className="row d-flex justify-content-center align-items-center">
                        <div className="col-12 col-md-6 col-lg-6 col-xl-6 px-4">

                          <PaymentForm pg={state.company.pg} razorpay_key={state.company.razorpay_key} name={state.company.name} company={state.company.company} mobile={state.company.mobile} cid={id} amount={defaultAmount} />

                        </div>
                      </div>

                    </div>
                  </section>
                </main>

              </div>
            </div>
          </>
          : <BgLoader />}
      </>
    </div>
  );
};

export default QuickPay;
